import React, { useState } from "react";  // ← Pas de useEffect !
import { 
    Card, Row, Col, Form, Button, Spinner, Alert,
    InputGroup
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";  // ← Pas de useParams !
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";

export default function AjouterFournisseur() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        code_fournisseur: '',
        raison_sociale: '',
        adresse: '',
        telephone: '',
        email: '',
        ice: '',
        patente: '',
        rc: '',
        identifiant_fiscal: '',
        cnss: '',
        conditions_reglement: ''
    });
    const [errors, setErrors] = useState({});
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [submitError, setSubmitError] = useState('');

    // ✅ PAS DE useEffect avec fetchFournisseur ici !

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        
        if (errors[name]) {
            setErrors({ ...errors, [name]: null });
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.raison_sociale) newErrors.raison_sociale = "La raison sociale est requise";
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const newErrors = validateForm();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setLoading(true);
        setSubmitError('');

        try {
            const token = localStorage.getItem("token");
            const response = await fetch('https://sawd.julesferry-ga.com/api/fournisseurs.php', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    action: 'create',
                    ...formData
                })
            });

            const result = await response.json();

            if (result.success) {
                setSubmitSuccess(true);
                setTimeout(() => {
                    navigate('/achats/fournisseurs');
                }, 1500);
            } else {
                setSubmitError(result.message || "Erreur lors de la création");
            }
        } catch (err) {
            setSubmitError("Erreur de connexion au serveur");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                <div className="container-fluid">
                    <Row className="mb-4">
                        <Col md={12}>
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h1 className="page-title mb-1">Nouveau fournisseur</h1>
                                    <p className="text-muted">Ajoutez un nouveau fournisseur</p>
                                </div>
                                <Button variant="outline-secondary" onClick={() => navigate('/achats/fournisseurs')}>
                                    <i className="ri-arrow-left-line me-2"></i>Retour
                                </Button>
                            </div>
                        </Col>
                    </Row>

                    {submitSuccess && (
                        <Alert variant="success">Fournisseur créé avec succès !</Alert>
                    )}

                    {submitError && (
                        <Alert variant="danger">{submitError}</Alert>
                    )}

                    <Card className="border-0 shadow-sm">
                        <Card.Body className="p-4">
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={6}>
                                        <h5 className="mb-3">Informations générales</h5>
                                        
                                        <Form.Group className="mb-3">
                                            <Form.Label>Raison sociale <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="raison_sociale"
                                                value={formData.raison_sociale}
                                                onChange={handleChange}
                                                isInvalid={!!errors.raison_sociale}
                                                required
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.raison_sociale}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Code fournisseur</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="code_fournisseur"
                                                value={formData.code_fournisseur}
                                                onChange={handleChange}
                                                placeholder="Laissé vide pour génération automatique"
                                            />
                                            <Form.Text className="text-muted">
                                                Généré automatiquement si non renseigné
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <h5 className="mb-3">Coordonnées</h5>
                                        
                                        <Form.Group className="mb-3">
                                            <Form.Label>Téléphone</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="telephone"
                                                value={formData.telephone}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Adresse</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="adresse"
                                                value={formData.adresse}
                                                onChange={handleChange}
                                                rows={2}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col md={12}>
                                        <h5 className="mb-3">Identifiants juridiques</h5>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>ICE</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="ice"
                                                value={formData.ice}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Patente</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="patente"
                                                value={formData.patente}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>RC</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="rc"
                                                value={formData.rc}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>IF</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="identifiant_fiscal"
                                                value={formData.identifiant_fiscal}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>CNSS</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="cnss"
                                                value={formData.cnss}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Conditions de règlement</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="conditions_reglement"
                                                value={formData.conditions_reglement}
                                                onChange={handleChange}
                                                rows={2}
                                                placeholder="Ex: Paiement à 30 jours, escompte de 2%..."
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="d-flex justify-content-end gap-2 mt-4">
                                    <Button variant="outline-secondary" onClick={() => navigate('/achats/fournisseurs')}>
                                        Annuler
                                    </Button>
                                    <Button type="submit" variant="primary" disabled={loading}>
                                        {loading ? <Spinner size="sm" /> : 'Enregistrer'}
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
                <Footer />
            </div>
        </>
    );
}